import * as React from 'react';
import { createApiClient } from '../../services/ApiClient';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';


interface Props{
    options: Array<any>;
    onSelect: (value: any) => void;
    onSearch: (value: any) => void;
}

interface State{
    value: string;
    isLoading: boolean;
}


class CompanyInput extends React.Component<Props, State>{
    constructor(){
        super();
        this.state = {
            value: '',
            isLoading: false
        };
        this.onChange = this.onChange.bind(this);
    }

    onChange(value){
        if(value.length > 0){
            this.props.onSelect(value[0].data.inn);
        }else{
            this.props.onSelect('');
        }
    }

    render(){
        const filterBy =() => true;

        const menuItemChildren=(option) =>{
            const title = `${option.data.inn || ''} ${option.data.ogrn || ''} ${!!option.data.address && option.data.address.data.source || ''}`;
            return (
                <div className="media" style={{whiteSpace: "normal"}}>
                    <div className="media-body">
                        <h4 className="media-heading menu-item-title">{!!option.data.opf && option.data.opf.short || ''} {!!option.data.name && option.data.name.full || ''}</h4>
                        <span className="menu-item-body" title={title} >{title}</span>
                    </div>
                </div>)
        }

        return <AsyncTypeahead
            id="company_complite"
            isLoading={this.state.isLoading}
            labelKey="value"
            multiple={false}
            emptyLabel="Неизвестная организация"
            searchText="Поиск"
            filterBy={filterBy}
            onChange={this.onChange}
            onSearch={this.props.onSearch}
            options={this.props.options}
            renderMenuItemChildren={menuItemChildren}
            placeholder="Введите название в свободной форме, ИНН или ОГРН"
        />
    }
}

export default CompanyInput;

